import { getBomTemplate } from "@/api/template";
import FileDownloader from "@/components/FileDownloader/FileDownloader";
import "@/components/HowItWorks.scss";
import Table from "@/components/Table/Table";

export default function ProductHowItWorks() {
  const dataSourceMultiple = [
    {
      key: "2",
      level: 0,
      product_id: "111111",
      name: "Blouse standard fit white",
      quantity: 1,
      unit: "unit",
    },
    {
      key: "3",
      level: 1,
      name: "Fabric",
      quantity: 170,
      unit: "g",
      supplier: "Sapphire Textile Mills Limited",
      supplier_address: "Punjab, Pakistan",
    },
    {
      key: "4",
      level: 2,
      name: "Silk, textile",
      quantity: 1.5,
      unit: "m2",
    },
    {
      key: "5",
      level: 2,
      name: "Thread",
      quantity: 200,
      unit: "m",
    },
    {
      key: "6",
      level: 3,
      name: "Cotton",
      quantity: 20,
      unit: "g",
    },
    {
      key: "7",
      level: 1,
      name: "Buttons",
      quantity: 8,
      unit: "items",
      supplier: "C&C Metal Products Corp.",
      supplier_address: "Englewood, US",
    },
    {
      key: "8",
      level: 2,
      name: "Brass",
      quantity: 5.2,
      unit: "g",
    },
    {
      key: "9",
      level: 1,
      name: "Labels",
      quantity: 1,
      unit: "item",
      supplier: "Unilabel Portugal",
      supplier_address: "Vila Nova, Portugal",
    },
    {
      key: "10",
      level: 2,
      name: "Polyester",
      quantity: 2,
      unit: "g",
    },
    {
      key: "11",
      level: 0,
      product_id: "222222",
      name: "Blouse standard fit blue",
      quantity: 1,
      unit: "unit",
    },
  ];

  const multipleProducts = (
    <>
      <div className="text-container">
        <h2>Uploading in 3 simple steps</h2>
        <ol>
          <li>
            Download{" "}
            <FileDownloader
              fileUrlFn={getBomTemplate}
              type="text"
              fileOutputName={`template-product-bom.xlsx`}
              buttonText="the template"
            />
            .
          </li>
          <li>
            Fill in the template or export a file from your systems including the requested columns
            shown in the example table below.
          </li>
          <li>Upload your file by clicking the blue box above or drag your file right into it.</li>
        </ol>
        <h2>Example template</h2>
      </div>
      <div className="data-container">
        <Table
          type={"grey"}
          data={dataSourceMultiple}
          columns={[
            {
              label: "Level *",
              key: "level",
            },
            {
              label: "Product ID *",
              key: "product_id",
            },
            {
              label: "Name",
              key: "name",
            },
            {
              label: "Quantity *",
              key: "quantity",
            },
            {
              label: "Unit *",
              key: "unit",
            },
            {
              label: "Supplier",
              key: "supplier",
            },
            {
              label: "Supplier address",
              key: "supplier_address",
            },
          ]}
          rowKey={"key"}
        />
      </div>
    </>
  );

  return (
    <div className="HowItWorks">
      <div className="container">
        <div className="text-container">
          <h1>Uploading Products & BOMs</h1>
          <p>
            Upload a bill of material (BOM) for each product that is purchased or sold by your
            company. Root uses this information to calculate your product impact.
          </p>
        </div>
        {multipleProducts}
        <div className="text-container">
          <h2>Frequently asked questions</h2>
          <div className="faq">
            <h3>What are levels and how to use them?</h3>
            <p>
              Levels create hierarchy in the BOM template. In this example, 'Blouse standard fit
              white' consists of 3 main parts: 'Fabric', 'buttons' and a 'label'. Here the 'fabric'
              is made of the material: 'silk, textile', the 'buttons' are made of the material:
              'brass', and the label is made of the material: 'polyester'. Within the part: 'fabric'
              there's a sub-part that's named: 'thread'. This 'thread' is made of the material:
              'cotton'.
            </p>
            <h3>Which units can I use?</h3>
            <p>
              We recommend using mass if you have that information available. However, for materials
              not expressed in grams, you can use any of the following units: g, m, m2, m3, or
              liter(l). Any other variations of the units defined earlier are also accepted, such as
              grams (kg) and cubic decimeters (dm3).
            </p>
            <h3>How do I provide supplier information for my materials?</h3>
            <p>
              We want to know where the materials of your product were manufactured. If you know the
              supplier of a particular material, please fill in that information in the
              corresponding row. Additionally, if you know the supplier of a particular part, we
              automatically assign that supplier to all the materials that make up that part.{" "}
            </p>
            <h3>I uploaded the wrong BOM for product, how can I fix it?</h3>
            <p>
              Navigate to the product where you uploaded the incorrect BOM, and click on the "Clear
              Data" button located at the top left of the screen. If you want to delete the BOM for
              multiple products, use the bulk select function on the product overview page and klik
              on “Delete BOM” button.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
